export default {
  getGalleryImages(param) {
    let images = [];
    switch (param) {
      case 'dom-kamionki':
        for (let i = 1; i < 29; i++) {
          images[i -
          1] = require('./assets/images/gallery/gallery-gadki/image' + i +
            '.jpg');
        }
        return images;
      case 'poznan':
        for (let i = 1; i < 30; i++) {
          images[i -
          1] = require('./assets/images/gallery/gallery-poznan/image' + i +
            '.jpg');
        }
        return images;
      case 'wroclaw':
        for (let i = 1; i < 43; i++) {
          images[i -
          1] = require('./assets/images/gallery/gallery-wroclaw/image' + i +
            '.jpg');
        }
        return images;
      case 'kuchnia-kamionki':
        for (let i = 1; i < 14; i++) {
          images[i -
          1] = require('./assets/images/gallery/gallery-kamionki/image' + i +
            '.jpg');
        }
        return images;
      case 'stomatolog-osiedle-river-park':
        for (let i = 1; i < 14; i++) {
          images[i -
          1] = require('./assets/images/gallery/gallery-dentysta/image' + i +
            '.jpg');
        }
        return images;
      case 'dusseldorf-wonder-photo-shop':
        for (let i = 1; i < 14; i++) {
          images[i -
          1] = require('./assets/images/gallery/gallery-photoshop/image' + i +
            '.jpg');
        }
        return images;
      case 'dom-leszno':
        for (let i = 1; i < 34; i++) {
          images[i - 1] = require('./assets/images/gallery/gallery-leszno/img' +
            i + '.jpg');
        }
        return images;
      default:
        return images;
    }
  },
};
